/**
 * Translation & Cultural Adaptation service page
 */
import { Link } from 'react-router'
import { Button } from '../../components/ui/button'
import { Globe, Languages, Users, CheckCircle } from 'lucide-react'

export default function TranslationPage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-violet-900 via-violet-800 to-purple-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h1 className="text-5xl font-bold mb-6">Translation & Cultural Adaptation</h1>
              <p className="text-xl text-violet-100 leading-relaxed mb-8">
                Expert translation and cultural adaptation services, with specialized focus on Iraqi markets and Turquality documentation support.
              </p>
              <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600">
                <Link to="/contact">Expand Globally</Link>
              </Button>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/3b6ebaf2-458c-4ad3-b2ae-0deb85ddc051.jpg" 
                alt="Translation Services"
                className="w-full h-80 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Translation Services</h2>
              <div className="space-y-4">
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-violet-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Marketing Content Translation</h3>
                    <p className="text-gray-600">Adapt your marketing messages for local markets</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-violet-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Cultural Adaptation</h3>
                    <p className="text-gray-600">Ensure your message resonates with local culture</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-violet-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Iraqi Market Specialization</h3>
                    <p className="text-gray-600">Expert knowledge of business culture.</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <CheckCircle className="h-6 w-6 text-violet-600 mt-1 mr-3 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Turquality Support</h3>
                    <p className="text-gray-600">Specialized services for Turkish global brands</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img 
                src="https://pub-cdn.sider.ai/u/U03VH4X1R0A/web-coder/68934572f1d36a2a58005e71/resource/62886ef6-def2-403e-a042-7f3e62e75329.png" 
                alt="Cultural Adaptation"
                className="w-full h-96 object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-r from-violet-900 to-purple-800 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold mb-6">Ready to Go Global?</h2>
          <p className="text-xl text-violet-100 mb-8">
            Let us help you communicate effectively across cultures and markets with expert translation services
          </p>
          <Button asChild size="lg" className="bg-orange-500 hover:bg-orange-600 text-lg px-8">
            <Link to="/contact">Get Translation Services</Link>
          </Button>
        </div>
      </section>
    </div>
  )
}
